<template>
  <div>
    <sc-page-loading v-if="loading" />
    <sc-analytics-status
      nameSpace="statusWaitingAvaliation"
      title="Aguardando Avaliação da Pré-Fatura"
      :rows="statusWaitingAvaliation"
      direction="bar"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScPageLoading } from '@intelipost-js/secure-components';
import ScAnalyticsStatus from '../analytics-status/ScAnalyticsStatus';

const {
  mapState,
  mapGetters,
  mapActions,
} = createNamespacedHelpers('recon/analytics/statusWaitingAvaliation');

export default {
  name: 'sc-analytics-status-waiting-avaliation',
  computed: {
    ...mapState([
      'loading',
    ]),
    ...mapGetters([
      'statusWaitingAvaliation',
    ]),
  },
  methods: {
    ...mapActions([
      'getStatusWaitingAvaliation',
    ]),
    loadData(form) {
      return this.getStatusWaitingAvaliation(form);
    },
  },
  components: {
    ScAnalyticsStatus,
    ScPageLoading,
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-status-waiting-avaliation/ScAnalyticsStatusWaitingAvaliation.vue?62de8340